import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mb-5" }
const _hoisted_2 = { class: "col-md-12 text-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-left text-primary" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "d-flex flex-column py-6"
}
const _hoisted_6 = { class: "container text-center mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_8 = { class: "text-muted fs-3 fw-bold mt-3 mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MachineCard = _resolveComponent("MachineCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: { name: 'certifications-to-do', params: { id: _ctx.certificationId } },
          class: "text-primary"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.back`)), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    (_ctx.machine)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.machine.id)
            ? (_openBlock(), _createBlock(_component_MachineCard, {
                key: 0,
                machine: _ctx.machine,
                certificationId: _ctx.certificationId
              }, null, 8, ["machine", "certificationId"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, "   " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
          ])
        ]))
  ]))
}